var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.648,
    height: 25.21,
    viewBox: "0 0 37.648 25.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.964,50.2a2.259,2.259,0,0,1-1.774-.021,12.606,12.606,0,1,0,0,22.577,2.26,2.26,0,0,1,1.774-.02A12.308,12.308,0,0,0,25.21,73.9a12.438,12.438,0,0,0,0-24.877A12.316,12.316,0,0,0,19.964,50.2Zm1.671,21.3c-.523-.188-.581-.671-.186-1.061a12.59,12.59,0,0,0,0-17.947c-.4-.39-.337-.873.186-1.061a10.5,10.5,0,0,1,3.574-.628,10.661,10.661,0,1,1,0,21.322A10.52,10.52,0,0,1,21.635,71.5Z",
    transform: "translate(0 -48.859)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.fc4ef734679fce50d4a05c29f847e434.svg";
export { ForwardRef as ReactComponent };